import { TableBody } from "@mui/material";
import { FC } from "react";
import { TestTableItem } from "../testTableItem";

interface IProps {
    testList: any[];
    handleStatus: (id: number, status: string) => void;
    handleDelete: (id: number) => void;
    handleUpload: (id: number, name: string) => void;
};

export const TestTableBody: FC<IProps> = ({ testList, handleDelete, handleStatus, handleUpload }) => {

    return (
        <TableBody>
            {testList.map(test => (
                <TestTableItem
                    test={test}
                    key={test.id}
                    handleStatus={handleStatus}
                    handleDelete={handleDelete}
                    handleUpload={handleUpload}
                />
            ))}
        </TableBody>
    )
};